/* eslint-disable react/destructuring-assignment */
import React from 'react';
import EnergiportalenCallToAction from '@componentsV2/EnergiPortalenCallToAction';
import { OverviewGridItem } from './components';

function TopPageSection({ maxWidth, smallVersion }) {
  const minActionButton = true;
  return (
    <OverviewGridItem showMaxwidth={maxWidth}>
      <EnergiportalenCallToAction
        minActionButton={minActionButton}
        smallVersion={smallVersion}
      />
    </OverviewGridItem>
  );
}

export default TopPageSection;
